export const useValidator = () => {
  const isNotBlank = (value) => {
    let trimed = value.replace(/(<([^>]+)>)/gi, '').trim();
    return trimed.length > 0;
  };

  return {
    isNotBlank
  };
};
